import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import moment from 'moment';
import classNames from 'classnames';


import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import {Checkbox} from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';


import Header from '@components/Header';

import { getReportTotalUsersReaders, getReportDetailUsersReaders, getPuestosDocument, getReportDetailUsersReadersDownload } from '@actions/documents';
import { getBusiness } from '@actions/business';

import { getValueLanguageObj } from '@utils/general';

import './style.scss'

const DEFAULT_EMPTY_TOTAL = "NA"
const DEFAULT_ROWS = 10

class ReportReaderDocuments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loadingTable: true,
      loadingBtnDownloadReport: false,
      detail: {},
      usersList: [],
      typeCountry: null,
      typeCompany: null,
      findText: '',
      catalogPuestos: [],
      catalogCompanies: [],
      showMissingReadings: false,
      total: DEFAULT_EMPTY_TOTAL,
      lectores: DEFAULT_EMPTY_TOTAL,
      faltantes: DEFAULT_EMPTY_TOTAL,
      lazyParams: {
        first: 0,
        rows: DEFAULT_ROWS,
        page: 0,
      },
      searchValues: {
        country: null,
        company: null,
        find: '',
      },
      countriesCurrentCatalogState: []
    };
  }

  async componentDidMount() {
    const { history, countriesCurrentCatalog, getPuestosDocument, t } = this.props
    if (!history.location.state?.id) return history.push('/documents')

    this.setState({detail: history.location.state?.detail})
    const countriesCurrentCatalogState = [... countriesCurrentCatalog]
    countriesCurrentCatalogState.unshift({label: t('Todos'), value: ''})
    if (history.location.state?.detail?.lectura) {
      const response = await getPuestosDocument(history.location.state.id)
      if (!response?.status) {
        this.setState({catalogPuestos: response.data})
      }
    }
    this.searchData();
    return this.setState({loadingPage: false, countriesCurrentCatalogState})
  }

  searchData = () => {
    const { findText, typeCountry, typeCompany, showMissingReadings } = this.state
    this.setState({
      searchValues: {
        country: typeCountry?.id || '',
        company: typeCompany?.id || '',
        find: findText || '',
        status: showMissingReadings ? "missing" : "all"
      },
    }, () => this.loadTotal())
  }

  loadTotal = async () => {
    const { getReportTotalUsersReaders } = this.props
    const { searchValues, detail } = this.state
    this.setState({ loadingTable: true });

    const querys = {}
    if (searchValues.country) querys.country = searchValues.country
    if (searchValues.company) querys.company = searchValues.company
    if (searchValues.find) querys.find = searchValues.find

    const response = await getReportTotalUsersReaders(detail.id, querys);
    if (!response?.status) {
      this.setState({
        total: response.data.total,
        lectores: response.data.lectores,
        faltantes: response.data.faltantes,
        lazyParams: {
          first: 0,
          rows: DEFAULT_ROWS,
          page: 0,
        },
      });
      this.loadData()
    } else {
      this.setState({
        total: DEFAULT_EMPTY_TOTAL,
        lectores: DEFAULT_EMPTY_TOTAL,
        faltantes: DEFAULT_EMPTY_TOTAL,
        loadingTable: false
      });
    }
  }

  loadData = async () => {
    const { getReportDetailUsersReaders } = this.props;
    const { lazyParams, searchValues, detail } = this.state;
    this.setState({ loadingTable: true });
    const querys = {
      page: lazyParams.page + 1,
      rows: lazyParams.rows,
      status: searchValues.status
    };
   
    if (searchValues.country) querys.country = searchValues.country
    if (searchValues.company) querys.company = searchValues.company
    if (searchValues.find) querys.find = searchValues.find
    const response = await getReportDetailUsersReaders(detail.id, querys);
    if (!response?.status) {
      return this.setState({
        usersList: response.data,
        loadingTable: false
      });
    } 
    return this.setState({
      usersList: [],
      lazyParams: {
        first: 0,
        rows: DEFAULT_ROWS,
        page: 0,
      },
      loadingTable: false,
    });
    
  };

  seCompaniesByCountry = async () => {
    const { getBusiness } = this.props
    const { typeCountry } = this.state
    this.setState({catalogCompanies: []})
    const params = {
      type: 'visible',
      country: typeCountry?.id || ''
    };
    const response = await getBusiness(params);
    if (!response?.status) {
      const catalogCompanies = response.data.map(item => ({ label: item.nombre, id: item.id }))
      return this.setState({catalogCompanies})
    }

  }

  onPage = (event) => {
    const { lazyParams } = this.state;
    const _lazyParams = { ...lazyParams, ...event };
    this.setState({ lazyParams: _lazyParams }, this.loadData);
  };

     
  onChange = ({target}) => {
    this.setState({[target.name]: target.value}, () => {
      if (target.name === "typeCountry") {
        if (target.value === "") return this.setState({typeCompany: null})
        this.seCompaniesByCountry()
      }
    });
  };

  onChangeCheckbox = (e) => {
    this.setState({[e.target.name]: e.checked}, () => {
      this.searchData()
    });
  };

  onDownloadReportReadersUsers = async () => {
    const { t, getReportDetailUsersReadersDownload } = this.props
    const { detail, searchValues } = this.state;
    this.setState({ loadingBtnDownloadReport: true });
    this.toastBR.show({severity:'info', summary: t('Reporte de lectura'), detail: t('Se esta generando el reporte de lectura.'), life: 3000});
    const querys = {
      isRequiredReading: !!detail.lectura
      // status: searchValues.status
    };

    // if (searchValues.country) querys.country = searchValues.country
    // if (searchValues.company) querys.company = searchValues.company
    // if (searchValues.find) querys.find = searchValues.find

    // if (!(searchValues.country || searchValues.find)) {
    //   confirmDialog({
    //     header: t('Reporte de lectura'),
    //     message: t('Para descargar el reporte, es necesario filtrar por país o por texto'),
    //     icon: 'pi pi-exclamation-triangle',
    //     acceptLabel: t('Cerrar'),
    //     rejectLabel: t('Cerrar'),
    //     rejectClassName: 'hide-component',
    //     accept: () => {},
    //     onHide: () => {}
    //   });
    //   return this.setState({loadingBtnDownloadReport: false})
    // }

    const response = await getReportDetailUsersReadersDownload(detail.id, detail.nombre, querys);
    if (response?.status) {
      confirmDialog({
        header: t('Reporte de lectura'),
        message: response?.status === 404 
          ? t('No se encontraron usuarios con los criterios proporcionados.')
          : t('Ha ocurrido un error, inténtelo más tarde.'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: t('Cerrar'),
        rejectLabel: t('Cerrar'),
        rejectClassName: 'hide-component',
        accept: () => {},
        onHide: () => {}
      });
    }
    this.setState({ loadingBtnDownloadReport: false });
  }

  validateRequieredReading = () => {
    const { workstationCatalog } = this.props
    const { catalogPuestos } = this.state
    let formatCatalogPuestos = [...catalogPuestos]
      formatCatalogPuestos = formatCatalogPuestos.reduce((accum, item) => {
        const isExistInCatalog = workstationCatalog.find(puesto => puesto.id === item)
        if (isExistInCatalog) accum.push(item)
        return accum
      }, [])
      formatCatalogPuestos = formatCatalogPuestos.join(', ')
    if (!formatCatalogPuestos.length) {
      formatCatalogPuestos = "--------------------"
    }
    return formatCatalogPuestos
  }

  columnResponsive = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData[detail.field]}
    </>
  )

  columnCountry = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {getValueLanguageObj(rowData.pais)}
    </>
  )

  columnFechaLectura = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {moment(rowData.fecha).locale(this.props.i18n.language).format("DD MMMM YYYY")}
    </>
  )

  render() {
    const { t } = this.props;
    const { detail,
      loadingPage,
      usersList,
      loadingTable,
      findText,
      lazyParams,
      showMissingReadings,
      typeCountry,
      typeCompany,
      catalogCompanies,
      total,
      lectores,
      faltantes,
      countriesCurrentCatalogState,
      loadingBtnDownloadReport
    } = this.state;

    let totalRecords = 0
    if (showMissingReadings) {
      totalRecords = faltantes === DEFAULT_EMPTY_TOTAL ? 0 : faltantes
    } else {
      totalRecords = lectores === DEFAULT_EMPTY_TOTAL ? 0 : lectores
    }
  
    if (loadingPage) return true


    return (
      <div className="p-grid report-readers">
        <div className="p-col-12">
          <Header
            title={t('Reporte de lectura')}
            to="/documents"
            linkText={t("Ir al listado")}
          />
          <div>
            <div className="p-grid card">
              <div className="p-col-12 p-md-2 p-lg-3">
                <p className="p-text-bold">{t('Nombre del documento')}</p>
                <p className="">{getValueLanguageObj(detail.nombre)}</p>
              </div>
              { detail?.lectura ? (
                <div className="p-col-12 p-md-2 p-lg-2">
                  <p className="p-text-bold">{t('Lectura obligatoria')}:</p>
                  <p className="">{this.validateRequieredReading()}</p>
                </div>
              ) : ""}
              <div className="p-col-12 p-md-2 p-lg-2">
                <p className="p-text-bold p-text-center">{t('Total de usuarios')}</p>
                <p className="p-text-center">{total}</p>
              </div>
              <div className={classNames("p-col-12 p-md-2 p-lg-2", {
                'border-selected': !showMissingReadings,
              })}>
                <p className="p-text-bold p-text-center">{t('Usuarios lectores')}</p>
                <p className="p-text-center">{lectores}</p>
              </div>
              <div className={classNames("p-col-12 p-md-2 p-lg-2", {
                'border-selected': showMissingReadings,
              })}>
                <p className="p-text-bold p-text-center">{t('Usuarios faltantes')}</p>
                <p className="p-text-center">{faltantes}</p>
              </div>
              <div className="p-col-12 p-md-2 p-lg-1 p-d-flex p-ai-center p-jc-center">
                <Button
                  type="button"
                  icon="pi pi-download"
                  className="p-button-lg"
                  onClick={() => this.onDownloadReportReadersUsers()}
                  tooltip={t("Descargar reporte")}
                  tooltipOptions={{position: 'top'}}
                  loading={loadingBtnDownloadReport}
                />
              </div>
            </div>

            <div className="p-col-12 p-mt-2 card">
              <div className='p-grid p-mb-5 p-mt-2'>
                <div className="p-col-12 p-lg-12 p-d-flex p-ai-center p-jc-end p-pr-5">
                  <Checkbox
                    name="showMissingReadings"
                    value
                    checked={showMissingReadings}
                    onChange={this.onChangeCheckbox}
                    className="p-mr-2"
                  />
                  {t('Ver solo los usuarios faltantes')}
                </div>
                <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center">
                  <label className="p-mr-2 p-text-bold">{t('País')}:</label>
                  <Dropdown
                    name="typeCountry"
                    value={typeCountry}
                    options={countriesCurrentCatalogState}
                    onChange={this.onChange}
                    optionLabel="label"
                    filter
                    // showClear
                    filterBy="label"
                    placeholder=""
                    style={{ width: '100%' }}
                  />
                </div>
                <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center">
                  <label className="p-mr-2 p-text-bold">{t('Empresa')}:</label>
                  <Dropdown
                      name="typeCompany"
                      value={typeCompany}
                      options={catalogCompanies}
                      onChange={this.onChange}
                      optionLabel="label"
                      filter
                      // showClear
                      filterBy="label"
                      placeholder=""
                      style={{ width: '100%' }}
                      disabled={!typeCountry}
                    />
                </div>
                {/* <div className="p-col-12 p-md-8 p-lg-8" /> */}
                <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center ">
                  <label className="p-mr-2 p-text-bold">{t('Texto')}:</label>
                    <InputText
                      name="findText"
                      value={findText}
                      onChange={this.onChange}
                      className="p-mr-2 input-search-list"
                      style={{'width': '58%'}}
                      // style={{ width: '100%' }}
                    />
                  <Button
                    icon="pi pi-search"
                    label={t('Buscar')}
                    className="p-button-raised p-button-text p-button-plain btn-search-list"
                    onClick={() => this.searchData()}
                  />
                </div>
              </div>

              <DataTable
                value={usersList}
                paginator={!!usersList.length}
                first={lazyParams.first}
                rows={lazyParams.rows}
                totalRecords={totalRecords}
                onPage={this.onPage}
                loading={loadingTable}
                stripedRows
                showGridlines
                lazy
                className="table-internals"
              >
                <Column
                  field="country"
                  header={t('País')}
                  body={this.columnCountry}
                  className="column-medium"
                />
                <Column
                  field="empresa"
                  header={t('Empresa')}
                  body={this.columnResponsive}
                />
                <Column
                  field="nombre"
                  header={t('Nombre')}    
                  body={this.columnResponsive}
                />
                <Column
                  field="correo"
                  header={t('Correo electrónico	')}
                  body={this.columnResponsive}
                />
                <Column
                  header={t('Puesto')}
                  field="puesto"
                  body={this.columnResponsive}
                  className="column-medium"
                />
                { !showMissingReadings && (
                  <Column
                    header={t('Fecha de lectura')}
                    body={this.columnFechaLectura}
                    className="p-text-center-lg column-medium"
                  />
                )}
              </DataTable>
              { !usersList.length && (
                  <div className="p-col-12 not-information">
                    {t('No se encontraron resultados')}
                  </div>
              )}
            </div>
          </div>
        </div>
        <Toast ref={(el) => this.toastBR = el} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  workstationCatalog: state.catalogs.workstationsCurrentCatalog,
  countriesCurrentCatalog: state.catalogs.countriesCurrentCatalog,
});

const mapDispatchToProps = {
  getBusiness,
  getReportDetailUsersReaders,
  getReportTotalUsersReaders,
  getPuestosDocument,
  getReportDetailUsersReadersDownload
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(ReportReaderDocuments);
